/* eslint-disable max-len */
import React, { Component } from 'react'
import * as urls from '../../../constants/socials'
import { Link } from 'react-router'
import { Button, Panel } from 'react-bootstrap'
import { translate } from 'react-translate'
import { DIST_URL } from '../../../constants/api'

import './FooterLarge.scss'

@translate('FooterLarge')
class FooterLarge extends Component {

  constructor (props) {
    super(props)

    this.state = {
      showSubsidiaries: false,
    }
    this.gotoTop = this.gotoTop.bind(this)
  }

  gotoTop(){
    window.scrollTo({top: 0, behavior: 'smooth'})
  }

  render(){
    const { subsidiaries, t } = this.props

    let centralSubsidiary = subsidiaries[0]
    let subsidiariesList = subsidiaries.slice(1)

    const subsidiariesRender = () => (<div className='content-footer'>
      <div className='middle-footer'>
        {subsidiariesList.map((item, index) =>
          <div className='column' key={index}>
            <h3>{item.title}</h3>
            <p>{item.address}</p>
            <div className={'contant-info'}>
              <span className='phone-bttn'>
                <h3 className='fot-icon'>
                  <i className='fa fa-phone' />
                  <a href={'tel:+' + item.code + item.telefono}>
                    ({item.code}) - {item.telefono.replace(/(\d{4})(\d{4})/, '$1-$2')}
                  </a>
                </h3>
              </span>
              <div className='whatsapp-bttn'>
                <Button className='btn-whatsapp' href={`https://api.whatsapp.com/send?phone=54911${item.telefono.replace(/\D+/g, '')}`} rel='noreferrer'>
                  <i className='fa fa-whatsapp' />
                  Whatsapp
                </Button>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>)
    const telLink = centralSubsidiary && 'tel:+' + centralSubsidiary.code + centralSubsidiary.telefono

    return(
      <footer className='Site-footer'>
        <div className='visible-sm visible-xs subsidiaries-info-container'>
          <Button bsStyle='link' className='btn-subsidiaries' onClick={() => this.setState(state => ({ showSubsidiaries: !state.showSubsidiaries }))}>
            {this.state.showSubsidiaries ? t('hide_subsidiaries') : t('our_subsidiaries')}
            &emsp;
            <i className={`fa fa-angle-${this.state.showSubsidiaries ? 'up' : 'down'} fa-lg`} />
          </Button>
          <Panel expanded={this.state.showSubsidiaries}>
            <Panel.Collapse>
              {subsidiariesRender()}
            </Panel.Collapse>
          </Panel>
        </div>
        <div className='hidden-sm hidden-xs'>
          {subsidiariesRender()}
        </div>
        <div className='up-footer-largo'>
          <div className='row'>
            <div className='col-sm-6 col-xs-12'>
              <div className='img-content'>
                <Link to='/'><img src={DIST_URL+'/assets/images/logo_ljr.png'} alt='LJRamos'/></Link>
              </div>
              { (centralSubsidiary) ? (
                <div className='info-content'>
                  <div className='title-subsidiary-footer'>{centralSubsidiary.title}</div>
                  <small className='hidden-xs'> {centralSubsidiary.address} </small>
                  <small className='visible-xs-inline-block'>{centralSubsidiary.address}</small>
                  <h3>
                    <a href={telLink}>({centralSubsidiary.code}) - {centralSubsidiary.telefono.replace(/(\d{4})(\d{4})/, '$1-$2')}</a>
                  </h3>
                  <div className='contact-link-icons'>
                    <a target='_blank' href={`https://api.whatsapp.com/send?phone=54911${centralSubsidiary.telefono.replace(/\D+/g, '')}`} rel='noreferrer'>
                        <i className='fa fa-whatsapp' />
                    </a>
                    <a target='_blank' href={telLink} rel='noreferrer'>
                        <i className='fa fa-phone'></i>
                    </a>
                    <a target='_blank' href={`mailto:${centralSubsidiary.mail}`} rel='noreferrer'>
                        <i className='fa fa-envelope'></i>
                    </a>
                  </div>
                  <div className='social-icons'>
                    <a href={urls.FACEBOOK} target='_blank' className='btn-social-circle btn-social-circle-grey' rel='noreferrer'>
                      <i className='fa fa-facebook' />
                    </a>
                    <a href={urls.TWITTER} target='_blank' className='btn-social-circle btn-social-circle-grey' rel='noreferrer'>
                      <i className='fa fa-twitter' />
                    </a>
                    <a href={urls.LINKEDIN} target='_blank' className='btn-social-circle btn-social-circle-grey' rel='noreferrer'>
                      <i className='fa fa-linkedin' />
                    </a>
                    <a href={urls.INSTAGRAM} target='_blank' className='btn-social-circle btn-social-circle-grey' rel='noreferrer'>
                      <i className='fa fa-instagram' />
                    </a>
                    <a href={urls.YOUTUBE} target='_blank' className='btn-social-circle btn-social-circle-grey' rel='noreferrer'>
                      <i className='fa fa-youtube-play' />
                    </a>
                  </div>
                </div> ) : '' }
            </div>
            <div className='col-sm-2 hidden-xs'>
              <div className='menu-footer'>
                <h2> {t('LA_EMPRESA')} </h2>
                <Link to='/empresa#directors'><h3> {t('Directorio')} </h3></Link>
                <Link to='/empresa#clients'><h3> {t('Clientes')} </h3></Link>
                <Link to='/empresa#sucursales'><h3> {t('Sucursales')} </h3></Link>
              </div>
              <div className='menu-footer'>
                <h2> {t('Informacion_Novedades')} </h2>
                <Link to='/informes-del-mercado-inmobiliario'><h3> {t('Informes_Mercado')} </h3></Link>
                <Link to='/newsletters'><h3> {t('Newsletters')} </h3></Link>
                <Link to='/noticias'><h3> {t('Noticias')} </h3></Link>
              </div>
            </div>
            <div className='col-sm-2 hidden-xs'>
              <div className='menu-footer'>
                <h2> {t('Divisiones')} </h2>
                <Link to='/residencial'><h3> {t('Residencial')} </h3></Link>
                <Link to='/sucursal/puertos'><h3> {t('Puertos')} </h3></Link>
                <Link to='/sucursal/sanisidro'><h3> {t('Lomas_San_Isidro')} </h3></Link>
                <Link to='/sucursal/nordelta'><h3> {t('Nordelta')} </h3></Link>
                <Link to='/sucursal/recoleta'><h3> {t('Recoleta')} </h3></Link>
                <Link to='/sucursal/palermo'><h3> {t('Palermo')} </h3></Link>
                <Link to='/sucursal/escobar'><h3> {t('Escobar')} </h3></Link>
                <Link to='/sucursal/pilar'><h3> {t('Pilar')} </h3></Link>
                <Link to='/oficinas'><h3> {t('Oficinas')} </h3></Link>
                <Link to='/locales'><h3> {t('Locales')} </h3></Link>
                <Link to='/industrias'><h3> {t('Industrias')} </h3></Link>
                <Link to='/campos'><h3> {t('Campos')} </h3></Link>
                {/* <Link to='/hoteles'><h3> {t('Hoteles')} </h3></Link> */}
                <Link to='/terrenos'><h3> {t('Terrenos')} </h3></Link>
              </div>
              <div className='afip-link hidden-xs'>
                <a target='blank' href='https://servicios1.afip.gov.ar/clavefiscal/qr/response.aspx?qr=Qub944MGvazxYjvy4JuaFg,,'>
                <img src={DIST_URL+'/assets/images/data-fiscal1.png'} alt='LJRamos' />
                </a>
              </div>
            </div>
            <div className='col-sm-2 hidden-xs'>
              <div className='menu-footer special-links hidden-xs'>
                <Link to='/emprendimientos'><h2> {t('Emprendimientos')} </h2></Link>
                <Link to='/tasaciones'><h2> {t('Tasaciones')} </h2>	</Link>
              </div>
              <div className='boton-to-top hidden-xs'>
                <Button className='btn-icons btn btn-default' onClick={() => this.gotoTop()}>
                  <i className='fa fa-angle-up' />
                </Button>
              </div>
            </div>
          </div>
        </div>
        <div className='bottom-footer text-center'>
          <div className='bottom-footer-content'>
            <small className='hidden-xs'> Aviso de Privacidad | Compromiso de Privacidad  |  Términos de Uso  |  Aviso de Cookies  |  Mapa del sitio  </small>
            <small> Copyright © 1989 - {(new Date().getFullYear())} L. J. Ramos. {t('Todos_los_derechos_reservados')}</small>
          </div>
        </div>
      </footer>
    )
  }
}

export default FooterLarge



// WEBPACK FOOTER //
// ./src/features/commons/Footer/FooterLarge.component.js